export default __webpack_public_path__ + "static/media/adobe-pdf-icon.ba4a9de7.svg";